import { render, staticRenderFns } from "./SystemParameterUpdate.vue?vue&type=template&id=0b0444bb"
import script from "./SystemParameterUpdate.vue?vue&type=script&lang=js"
export * from "./SystemParameterUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports